/**
 * Chronos Watch Shop - Application Root Component
 * 
 * Sets up routing and global providers for the luxury watch e-commerce store.
 * - CartProvider: Manages shopping cart state across the application
 * - BrowserRouter: Handles client-side navigation
 * - Toaster: Displays toast notifications for user feedback
 */

import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderConfirmation from "@/pages/OrderConfirmation";
import { CartProvider } from "@/context/CartContext";

function App() {
  return (
    <CartProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/order-confirmation" element={<OrderConfirmation />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" />
      </div>
    </CartProvider>
  );
}

export default App;
